import { IDivision } from '@app/divisions/shared/division.interface';

export class Division implements IDivision {
  id: string;
  abbreviation: string;
  description: string;

  constructor(id?: string, abbreviation?: string, description?: string) {
    this.id = id;
    this.abbreviation = abbreviation;
    this.description = description;
  }
}
